import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getUsers = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/users/list`, {params});
};

export {
    getUsers
}